import { InlineSelectProps, useInlineSelectOverrides } from '@gorila-shared-ui/components';
import { Select } from 'baseui/select';

export function InlineSelect({
  value,
  onChange,
  options,
  label,
  searchable = false,
  disabled = false,
  labelKey,
  valueKey,
  onInputChange,
  filterOptions,
}: Readonly<InlineSelectProps>) {
  const overrides = useInlineSelectOverrides(label);
  return (
    <Select
      closeOnSelect
      openOnClick
      clearable={false}
      onChange={onChange}
      options={options}
      searchable={searchable}
      size={'compact'}
      value={value}
      disabled={disabled}
      labelKey={labelKey}
      valueKey={valueKey}
      onInputChange={onInputChange}
      filterOptions={filterOptions}
      overrides={overrides}
    />
  );
}
